import { Divider, Stack, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { getAppConfig } from '../../sharedComponents/src/globalHeader/services/AppConfigService'
import { useScreenSize } from '../../sharedComponents/src/hooks/useScreenSize'
import { isIOS } from '../../sharedComponents/src/utils/detectBrowser'
import DownloadApp from './DownloadApp'

const DownloadAppBanner: React.FC = () => {
    const { isMobile } = useScreenSize()
    const [isIOSDevice, setIsIOSDevice] = useState<boolean>(false)
    const [isMobileApp, setIsMobileApp] = useState<boolean>(false)

    useEffect(() => {
        const config = getAppConfig()
        if (config?.isMobileApp) {
            setIsMobileApp(true)
        } else if (isMobile) {
            setIsMobileApp(false)
            setIsIOSDevice(isIOS())
        } else {
            setIsMobileApp(false)
            setIsIOSDevice(false)
        }
    }, [isMobile])

    const handleAppleAppClick = () => {
        window.open('https://apps.apple.com/ua/app/chess-at-icc-play-learn/id643326555', '_blank')
    }

    const handleAndroidAppClick = () => {
        window.open('https://play.google.com/store/apps/details?id=com.chessclub.android&pli=1', '_blank')
    }

    // Show logic
    const showAppleButton = !isMobile || isIOSDevice
    const showAndroidButton = !isMobile || (!isIOSDevice && isMobile)

    if (isMobileApp) return null

    return (
        <>
            <Divider flexItem sx={{ borderColor: '#252636', borderWidth: '1px' }} />
            <Typography variant={isMobile ? 'h6' : 'h5'} textTransform="uppercase">
                ICC is better on the go!
            </Typography>
            <Stack direction="row" gap={1.5}>
                {showAppleButton && (
                    <DownloadApp
                        image="/assets/images/main-menu/apple-app.svg"
                        alt="Download on the App Store"
                        onClick={handleAppleAppClick}
                    />
                )}
                {showAndroidButton && (
                    <DownloadApp
                        image="/assets/images/main-menu/android-app.svg"
                        alt="Get it on Google Play"
                        onClick={handleAndroidAppClick}
                    />
                )}
            </Stack>
        </>
    )
}

export default DownloadAppBanner
